import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {KeHoachService} from '../../../service/kehoach/service-kehoach';
import {KeHoachFileService} from '../../../service/kehoach/service-kehoachfile';
import {Subject} from 'rxjs';
import {KeHoachFile} from '../../../models/kehoach/kehoachfile';
import {KeHoach} from '../../../models/kehoach/kehoach';
import {CommandUtil} from '../../../global/commandutil';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  templateUrl: './detail.component.html'

})
export class DetailKeHoachComponent implements OnInit, AfterViewInit {
  public language = language;
  public isEdit: boolean = false;
  public keHoachItem: KeHoach = new KeHoach();
  public  keHoachFiles: KeHoachFile[] = [];
  public onClose: Subject<boolean>;
  constructor( public keHoachService: KeHoachService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public keHoachFileService: KeHoachFileService,
               public commandUtil: CommandUtil,
               public _bsModalRef: BsModalRef,
               public sanitizer: DomSanitizer

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {

    this.keHoachService.getById(id).pipe(first())
      .subscribe(x => this.keHoachItem = x);


    this.keHoachFileService.findAllByKeHoachId(id).subscribe(
      x => { this.keHoachFiles = x;  });
  }

  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

